import { atom } from 'recoil';

export interface ChatbotSessionState {
  threadId?: string;
  isThreadPersisted: boolean;
  shouldFocusInput?: boolean;
  skipResume?: boolean;
}

export const chatbotSessionState = atom<ChatbotSessionState>({
  key: 'chatbotSessionState',
  default: {
    threadId: undefined,
    isThreadPersisted: false,
    skipResume: false,
  },
});
